import { IFreeSpinInfoResponse, IFreeSpinInfoView } from './interfaces/Slots/Outcome'
import { ISlotViewItem } from './interfaces/Slots/Slots'

export interface IExtraData {
  url: string
  authRequired?: boolean
  converter?: (data: any) => any
}

export interface ISessionUrlData {
  url: string
  method?: string
  freeSpinUrl?: string
  freeSpinInfoUrl?: string
  freeSpinInfoConverter?: (data: IFreeSpinInfoResponse) => IFreeSpinInfoView
  demoUrl?: string
  getQuery?: (params: any) => string
  converter?: (data: any) => string
  getBody?: (params: any) => object
  getHeaders?: (params: any) => object
  isNeedDoubleRequest?: boolean
}

export interface ISlotProviderConfigurationItem<CT> {
  multiProvider?: boolean
  liveGamesProviders?: string[]
  uniqueField?: boolean
  platform?: string[]
  gameListUrl: string | string[]
  extraData?: IExtraData[]
  defaultList?: ISlotViewItem[]
  converter: CT
  withoutLoading?: boolean
  sessionUrlData?: ISessionUrlData
  authRequired?: boolean
  withoutActionProcessing?: boolean
}

export const Providers = {
  SOFTSWISS: 'softwiss',
  OUTCOME: 'otc',
  SOFTGAMING: '028142ca',
  DIRECT_PRAGMATIC: '08f21347',
  // BCRAFT: 'b480999a',
  DIGITAIN: '81339664',
  KELT_GAMES: '20c90087',
} as const

export type ProvidersType = ReverseMap<typeof Providers>

export type ISlotProvidersConfiguration<CT> = {
  [key: string]: ISlotProviderConfigurationItem<CT>
}
